import {Component, inject} from '@angular/core';
import {register} from 'swiper/element/bundle';
import {IonApp, IonRouterOutlet} from '@ionic/angular/standalone';
import {UpdateService} from './services/update.service';

register();

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  imports: [IonApp, IonRouterOutlet]
})
export class AppComponent {

  private updateService = inject(UpdateService);

}
